/**
 * This exception is thrown when a Forbidden Http Response is given by API
 */
export class HttpForbiddenException extends Error {}

/**
 * This exception is thrown when a Unauthorized Http Response is given by API
 */
export class HttpUnauthorizedException extends Error {}
